import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6029b89p: FaireBrandEntity = {
  token: "b_6029b89p",
  type: "brand",
  name: "Sail Away Coffee Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/6550c702bab674d20d1631a72994b561ce1932df5cffc67bcc2fb0860c05a9c4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/68697212dd113701de5f5a86bebc3861952ec1ccc181473ffbd7434b0a821886.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6550c702bab674d20d1631a72994b561ce1932df5cffc67bcc2fb0860c05a9c4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/68697212dd113701de5f5a86bebc3861952ec1ccc181473ffbd7434b0a821886.png",
  location: "Deer Park, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 64,
  isTopShop: true,
  isInsider: true,
  description:
    "Sail Away was born from the rhythm of the road — and the discovery of coffee at its source. As a touring musician, our founder Christopher Vetter lived on long days, late nights, and caffeine pit stops wherever the road led. But a tour through Central America changed everything. There, tasting coffee at its origin revealed the craft, culture, and passion behind every bean.\n\nBack home in New York, that spark became an obsession. Chris fell in love with cold brew and spent months perfecting a recipe that struck every note — smooth, bold, and balanced. What began as a small kitchen experiment soon grew into samples at farmers’ markets, and before long, Sail Away was fueling everyone from local bagel shops to concert arenas.\n\nToday, Sail Away is more than just coffee. It’s a reminder that great taste doesn’t need to be complicated — just crafted with care, curiosity, and a spirited sense of adventure. Anchored by our slogan “Stay Buzzed,” we remain rooted in New York, with our vision set on new horizons — exploring new flavors, formats, and ways to bring people together, one smooth sip at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:49.034Z",
    importedBy: "entity-db-cli",
  },
};
